module.exports = __webpack_public_path__ + "static/media/coffee-cup.605b002d.svg";